import { MentorsPage as Mentors } from '@/pages/Admin/Mentors'
import { MentorsIndividualPage as IndividualsMentor } from '@/pages/Admin/Mentors/Individual'

export const mentorsRoutes: Array<RoutesType> = [
	{
		name: 'Mentorias',
		path: '/mentorias',
		layout: 'credits',
		roles: ['student'],
		hideInSidebar: true,
		element: Mentors,
		isPrivate: true,
	},
	{
		name: 'Perfil Mentor',
		path: '/mentorias/:slug',
		layout: 'credits',
		roles: ['student'],
		hideInSidebar: true,
		element: IndividualsMentor,
		isPrivate: true,
	},
]
